import {
  Alert,
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  Row,
  Tag,
} from "antd";
import FullPageLayout from "../../../templates/FullPageLayout";
import { DeleteIcon, NeedHelp } from "../../../atoms/CustomIcons";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { MoreOutlined } from "@ant-design/icons";
import { SelectField } from "../../../atoms/FormFields";
interface FormValues {
  select_client: string;
}

export default function TransferProperty() {
  const [loading, setLoading] = useState(false);
  const { handleSubmit, control } = useForm<FormValues>();
  const navigate = useNavigate();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const onSubmit = (val: FormValues) => {
    setLoading(true);
    console.log("Form submitted with values:", val);
    setLoading(false);
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<DeleteIcon />}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <FullPageLayout loading={loading}>
      <Form
        className="propertyForm"
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Button className="btn-sm fixedTopBtn">
          <NeedHelp /> Need help?
        </Button>

        <div style={{ paddingBottom: 80 }}>
          <Row gutter={8} style={{ width: "672px" }}>
            <Col span={24}>
              <div
                className="title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <h2> Transfer property to another client </h2>
                  <p> Select a new owner of the property below. </p>
                </div>
              </div>

              <div className="alertWrapper" style={{ marginBottom: "8px" }}>
                <Alert
                  message="Transfer property ownership"
                  description="All open deals or contracts must be closed before transfer. Their history will remain in both the previous owner’s profile and the property profile."
                  type="info"
                  showIcon
                  closable
                />
              </div>
            </Col>

            <Col span={24}>
              <Card>
                <Row gutter={20}>
                  <Col span={24} style={{ marginBottom: "16px" }}>
                    <h4 style={{ marginBottom: "4px" }}> Current client </h4>
                  </Col>

                  <Col span={24}>
                    <div
                      className="titleBar"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "21px",
                      }}
                    >
                      <div>
                        <span
                          className="userName"
                          style={{
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: "700",
                            color: "#151718",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Education company
                          <Tag
                            className="default_tag"
                            style={{
                              marginLeft: "8px",
                              textTransform: "capitalize",
                            }}
                          >
                            company
                          </Tag>
                        </span>
                      </div>
                    </div>
                    <div
                      className="contactData"
                      style={{ display: "flex", gap: "8px" }}
                    >
                      <div
                        className="labelText"
                        style={{ color: "#6C7478", minWidth: "50px" }}
                      >
                        Address:
                      </div>
                      <div className="ValueText">
                        123 Maple Street San Francisco, CA 34567
                      </div>
                    </div>
                    <div
                      className="contactData"
                      style={{ display: "flex", gap: "8px" }}
                    >
                      <div
                        className="labelText"
                        style={{ color: "#6C7478", minWidth: "50px" }}
                      >
                        Phone:
                      </div>
                      <div className="ValueText">+92 315 34566645</div>
                    </div>
                    <div
                      className="contactData"
                      style={{ display: "flex", gap: "8px" }}
                    >
                      <div
                        className="labelText"
                        style={{ color: "#6C7478", minWidth: "50px" }}
                      >
                        Email:
                      </div>
                      <div className="ValueText">dhs@darkhorsesolutions.co</div>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <img src="/images/company/arrow_container.svg" alt="" />
            </div>

            <Col span={24}>
              <Card>
                <Row gutter={20}>
                  <Col span={24} style={{ marginBottom: "16px" }}>
                    <h4 style={{ marginBottom: "4px" }}> New client </h4>
                    <p>Select new property owning company or individual.</p>
                  </Col>
                  <Col span={24}>
                    <SelectField
                      fieldName="select_client"
                      control={control}
                      selectOption={[]}
                      iProps={{
                        placeholder: "Select existing or create a new one",
                      }}
                      className="bottom_0"
                    />
                  </Col>

                  <Col span={24}>
                    <Card style={{ marginBottom: "0px", marginTop: "8px" }}>
                      <div
                        className="titleBar"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "21px",
                        }}
                      >
                        <div>
                          <span
                            className="userName"
                            style={{
                              fontSize: "16px",
                              lineHeight: "24px",
                              fontWeight: "700",
                              color: "#151718",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Education company
                            <Tag
                              className="default_tag"
                              style={{
                                marginLeft: "8px",
                                textTransform: "capitalize",
                              }}
                            >
                              company
                            </Tag>
                          </span>
                        </div>
                        <div className="actionBtns">
                          <Dropdown
                            menu={{ items }}
                            trigger={["click"]}
                            placement="bottomRight"
                            className="actionButton"
                          >
                            <Button
                              onClick={(x) => {
                                x.stopPropagation();
                              }}
                              onKeyDown={(e) => e.stopPropagation()}
                              style={{
                                padding: "0px",
                                height: "auto",
                                border: "unset",
                                backgroundColor: "transparent",
                              }}
                              ref={dropdownRef}
                              className="only_icon"
                              icon={<MoreOutlined />}
                            />
                          </Dropdown>
                        </div>
                      </div>

                      <div
                        className="contactData"
                        style={{ display: "flex", gap: "8px" }}
                      >
                        <div
                          className="labelText"
                          style={{ color: "#6C7478", minWidth: "50px" }}
                        >
                          Address:
                        </div>
                        <div className="ValueText">
                          123 Maple Street San Francisco, CA 34567
                        </div>
                      </div>
                      <div
                        className="contactData"
                        style={{ display: "flex", gap: "8px" }}
                      >
                        <div
                          className="labelText"
                          style={{ color: "#6C7478", minWidth: "50px" }}
                        >
                          Phone:
                        </div>
                        <div className="ValueText">+92 315 34566645</div>
                      </div>
                      <div
                        className="contactData"
                        style={{ display: "flex", gap: "8px" }}
                      >
                        <div
                          className="labelText"
                          style={{ color: "#6C7478", minWidth: "50px" }}
                        >
                          Email:
                        </div>
                        <div className="ValueText">
                          dhs@darkhorsesolutions.co
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <div className="fixed_btm_card">
            <Card>
              <div className="centered">
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  onClick={() => navigate(`/properties/${companyId}`)}
                >
                  Cancel
                </Button>
                <div style={{ display: "flex", gap: "16px" }}>
                  <Button htmlType="submit" type="primary" className="mint-btn">
                    Complete transfer
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </Form>
    </FullPageLayout>
  );
}
